import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, LOCALE_ID, inject } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class AcceptLanguageInterceptor implements HttpInterceptor {
  private locale = inject(LOCALE_ID);

  private readonly language: string;

  constructor() {
    const locale = this.locale;

    this.language = locale.substring(0, 2).toLowerCase();
  }

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const clonedRequest = req.clone({
      headers: req.headers.set('Accept-Language', this.language),
    });
    return next.handle(clonedRequest);
  }
}
